// web/src/pages/Login.tsx
import { useState } from "react";
import type { FormEvent } from "react";

import { call, type Me } from "../lib/api";

// Одно поле, и ни слова о том, как завести пароль: заводят и отзывают его в
// CRM, поэтому ссылка на восстановление была бы обещанием, которого этот
// раздел не исполняет.
export function Login({ onEnter }: { onEnter: (me: Me) => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    // Кнопка и так задизейблена на время запроса, но disabled — это подсказка
    // браузеру, а не барьер: синхронный повторный вызов (двойной Enter,
    // двойной клик до перерисовки) её обходит.
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const reply = await call<Me>("/api/login", { password });
      if (reply.results) onEnter(reply.results);
      else setError(reply.error[0]?.message ?? "Не удалось войти");
    } finally {
      // Обязаны сбросить при любом исходе: иначе сбой (сеть, не-JSON ответ)
      // оставляет кнопку на «Проверяем…» и пароль — в состоянии компонента.
      setBusy(false);
      setPassword("");
    }
  }

  return (
    <form onSubmit={submit} className="mx-auto mt-32 flex w-72 flex-col gap-3">
      <h1 className="text-[13px] font-medium text-fg">fbsozon</h1>
      <input
        type="password"
        autoFocus
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Пароль"
        className="h-[38px] rounded-[var(--radius-ui)] border border-border bg-bg px-3 text-[13px] text-fg outline-none focus:border-border-strong"
      />
      <button
        disabled={busy || !password}
        className="h-[38px] rounded-[var(--radius-ui)] border border-border text-[13px] text-fg hover:bg-bg-hover disabled:opacity-50"
      >
        {busy ? "Проверяем…" : "Войти"}
      </button>
      {error && <div className="text-[13px] text-err">{error}</div>}
    </form>
  );
}
